import { HStack, useBreakpointValue } from 'native-base';
import PaymentOptionCard from '../PaymentOptionCard';
import React, { memo } from 'react';
const OptionCardLayout = _ref => {
  let {
    amountOne,
    amountTwo,
    shortageOrSpread,
    effectiveDate,
    onPayNowClick,
    timeFrame
  } = _ref;
  const flexDirection = useBreakpointValue({
    base: 'column',
    md: 'row',
    lg: 'row'
  });
  return /*#__PURE__*/React.createElement(HStack, {
    flexDirection: flexDirection,
    justifyContent: 'center',
    alignItems: "center",
    space: {
      base: 0,
      md: 0,
      lg: 20
    },
    flex: 1,
    testID: "payment-options-displayed"
  }, /*#__PURE__*/React.createElement(PaymentOptionCard, {
    type: "Option 1",
    amount: amountOne,
    date: effectiveDate,
    shortage: shortageOrSpread,
    timeFrame: timeFrame
  }), /*#__PURE__*/React.createElement(PaymentOptionCard, {
    type: "Option 2",
    amount: amountTwo,
    date: effectiveDate,
    shortage: shortageOrSpread,
    onPayNowClick: onPayNowClick
  }));
};
export default /*#__PURE__*/memo(OptionCardLayout);
//# sourceMappingURL=index.js.map